// NextLinkとしてauto importできるようにしたいだけ
import Link from 'next/link'
export const NextLink = Link
